import React, { Component, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import Routes from "./Routes";

import "./Vendor";
import "./styles/bootstrap.scss";
import "./styles/app.scss";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./styles/otr/css/style.css";
import "./styles/otr/css/login.css";

class App extends Component {
    render() {
        const basename = "/";

        return (
            <Suspense fallback={<div>Loading...</div>}>
                <I18nextProvider i18n={i18n}>
                    <BrowserRouter basename={basename}>
                        <Routes />
                    </BrowserRouter>
                </I18nextProvider>
            </Suspense>
        );
    }
}

export default App;
